import { render, staticRenderFns } from "./CpurchasingIndex.vue?vue&type=template&id=4c33d06c"
import script from "./CpurchasingIndex.vue?vue&type=script&lang=js"
export * from "./CpurchasingIndex.vue?vue&type=script&lang=js"
import style0 from "./CpurchasingIndex.vue?vue&type=style&index=0&id=4c33d06c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports